<template>
  <div>
    <div class="group">
      <div class="fruit-bg">
        <!-- <div class="wrong_count">
          <p class="wrong_sign"></p>
        </div> -->
        <div
          class="fruit_con"
          :style="{ left: fruitLeft + 'px', bottom: fruitBottom + 'px' }"
        >
          <!-- <div class="boom_kiwi"></div>
          <div
            class="kiwi_friut"
          >
            H
          </div> -->
          <div
            v-show="shotWord.status === 'right'"
            :class="[`boom_${shotWord.kind}`]"
          ></div>
          <div
            :class="[
              shotWord.status === 'right'
                ? `boomed_${shotWord.kind}_friut`
                : `${shotWord.kind}_friut`,
            ]"
          >
            {{ shotWord.word }}
          </div>
        </div>
      </div>
    </div>
    <successDialog
      v-if="showDialog"
      @clickConfirm="clickConfirm"
      @clickClose="clickClose"
      :is-confirm-dialog="true"
      :dialog-title="'Congratulations'"
      :dialog-img="dialogImg"
    >
    </successDialog>
  </div>
</template>

<script>
import dialog from "../views/mixins/dialog";
export default {
  name: "ShotStyle",
  props: {
    shotWordData: {
      type: String,
      default: "Javascript",
    },
    dialogImg: {
      type: String,
      default: "",
    },
  },
  mixins: [dialog],
  data() {
    return {
      fruitLeft: 150,
      startLeft: 0,
      fruitBottom: -70,
      shotWord: "",
      timer: null,
      moveTimer: null,
      worngNum: 0,
      activeIndex: -1,
      shotArr: [],
    };
  },
  watch: {
    shotWord(newValue, oldValue) {
      if (oldValue.status === "normal") {
        this.worngNum++;
        console.log("前一题错了");
      }
    },
    worngNum(val) {
      if (val * 1 === 3) {
        console.log("GAME OVER～");
        this.timer && clearInterval(this.timer);
        this.moveTimer && clearInterval(this.moveTimer);
      }
    },
  },
  mounted() {
    this.shotData();
    this.timer = setInterval(() => {
      this.startLeft = Math.random() * (300 - 100) + 100;
      this.fruitLeft = this.startLeft;
      this.fruitBottom = -70;
      if (this.activeIndex === this.shotArr.length) {
        clearInterval(this.timer);
      } else {
        this.activeIndex++;
        this.shotWord = this.shotArr[this.activeIndex];
      }
    }, 5000);
    this.moveTimer = setInterval(() => {
      if (this.activeIndex === this.shotArr.length) {
        clearInterval(this.moveTimer);
      } else {
        this.fruitMove();
      }
    }, 25);
    console.log(this.shotArr, "shotArr");
  },
  beforeDestroy() {
    this.worngNum = 0;
    this.timer && clearInterval(this.timer);
    this.moveTimer && clearInterval(this.moveTimer);
  },
  methods: {
    shotData() {
      let fruitKind = [
        "kiwi",
        "lemon",
        "peach",
        "apple",
        "greenApple",
        "pomegranate",
        "orange",
      ];
      let originArr = Array.from(new Set(this.shotWordData));
      originArr.forEach((ele, idx) => {
        let obj = {
          word: ele,
          status: "normal",
          kind: fruitKind[idx % fruitKind.length],
        };
        this.shotArr.push(obj);
      });
    },
    handlerWord(key) {
      let keyActiveObj = this.shotArr[this.activeIndex];
      if (key === keyActiveObj.word) {
        this.$set(keyActiveObj, "status", "right");
        console.log(this.shotArr, "change");
      } else {
        this.$set(keyActiveObj, "status", "wrong");
        this.worngNum++;
        console.log(this.worngNum, "this.worngNum");
      }
    },
    fruitMove() {
      // let limitTop
      const ySpeed = 6;
      const xSpeed = ((400 - this.startLeft) * 3) / 170;
      if (this.fruitLeft > 400) {
        this.fruitLeft += xSpeed;
        this.fruitBottom -= ySpeed;
      } else {
        this.fruitBottom += ySpeed;
        this.fruitLeft += xSpeed;
      }
    },
    nextKey() {
      return this.shotArr[this.activeIndex + 1].word;
    },
    nextWord() {
      return this.shotArr[this.activeIndex].word;
    },
  },
};
</script>

<style scoped lang="less">
.group {
  margin: 0 auto;
  height: 400px;
  width: 800px;
  margin: 0 auto;
  margin-bottom: 20px;
  overflow: hidden;
  .fruit-bg {
    width: 800px;
    height: 400px;
    position: relative;
    background-image: url("../assets/images/fruit_bg.webp");
    background-position: -0px -150px;
    .fruit_con {
      position: absolute;
      div[class^="boom_"] {
        position: absolute;
        width: 62px;
        height: 207px;
        z-index: 2;
        opacity: 0;
        background-image: url("../assets/images/fruit.webp");
        animation: boom 0.3s ease;
      }

      .boom_kiwi,
      .boom_greenApple {
        background-position: -171px -843px;
      }
      .boom_lemon {
        background-position: -761px -472px;
      }
      .boom_orange {
        background-position: -675px -730px;
      }
      .boom_apple,
      .boom_pomegranate,
      .boom_peach {
        background-position: -739px -947px;
      }
      div[class$="_friut"] {
        font-size: 60px;
        text-align: center;
        color: gold;
        &::before {
          position: absolute;
          display: block;
          content: "";
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          background-image: url("../assets/images/fruit.webp");
        }
        &::after {
          position: absolute;
          display: block;
          content: "";
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          background-image: url("../assets/images/fruit.webp");
        }
      }
      div[class^="boomed_"] {
        opacity: 0;
        animation: boom 0.3s ease;
        // &::before {
        //   transform: rotate(0.5turn);
        // }
        // &::after {
        //   transform: rotate(0.25turn);
        // }
      }
      div[class$="lemon_friut"] {
        width: 50px;
        margin-bottom: 106px;
        &::before {
          width: 43px;
          height: 44px;
          background-position: -369px -1114px;
        }
        &::after {
          width: 44px;
          height: 52px;
          background-position: -415px -1114px;
        }
      }
      div[class$="kiwi_friut"] {
        width: 53px;
        margin-bottom: 106px;
        &::before {
          width: 46px;
          height: 45px;
          z-index: 2;
          background-position: -929px -580px;
        }
        &::after {
          z-index: 1;
          width: 48px;
          height: 45px;
          background-position: -864px -863px;
        }
      }
      div[class$="peach_friut"] {
        width: 68px;
        margin-bottom: 121px;
        &::before {
          width: 59px;
          height: 65px;
          background-position: -556px -1032px;
        }
        &::after {
          width: 56px;
          height: 64px;
          background-position: -912px -955px;
        }
      }
      div[class$="apple_friut"] {
        width: 56px;
        margin-bottom: 114px;
        &::before {
          width: 48px;
          height: 52px;
          background-position: -929px -523px;
        }
        &::after {
          width: 48px;
          height: 54px;
          background-position: -927px -726px;
        }
      }
      div[class$="greenApple_friut"] {
        width: 56px;
        margin-bottom: 114px;
        &::before {
          width: 48px;
          height: 58px;
          background-position: -926px -467px;
        }
        &::after {
          width: 45px;
          height: 49px;
          background-position: -673px -1111px;
        }
      }
      div[class$="pomegranate_friut"] {
        width: 56px;
        margin-bottom: 114px;
        &::before {
          width: 57px;
          height: 67px;
          background-position: -856px -796px;
        }
        &::after {
          width: 51px;
          height: 58px;
          background-position: -918px -1017px;
        }
      }
      div[class$="orange_friut"] {
        width: 60px;
        margin-bottom: 114px;
        &::before {
          width: 63px;
          height: 67px;
          background-position: -408px -553px;
        }
        &::after {
          width: 52px;
          height: 45px;
          background-position: -316px -1086px;
        }
      }
      div.boomed_peach_friut {
        width: 106px;
      }
      div.boomed_apple_friut,
      div.boomed_greenApple_friut,
      div.boomed_kiwi_friut,
      div.boomed_orange_friut,
      div.boomed_pomegranate_friut,
      div.boomed_lemon_friut {
        width: 76px;
      }
    }
    .wrong_count {
      .wrong_sign {
        width: 35px;
        height: 35px;
        background-image: url("../assets/images/fruit.webp");
        background-position: -306px -1132px;
      }
    }
  }
}
@keyframes boom {
  0% {
    opacity: 0.1;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.1;
  }
}
</style>
